<template>
  <div class="list-container" :class="{ empty: showEmpty }">
    <div class="list-header">
      <div class="title">
        <template v-if="state.checkable">
          <a-checkbox
            v-model:checked="state.checkAll"
            :indeterminate="state.indeterminate"
            :disabled="!checkAllList.length"
            @change="onCheckAllChange"
          >
            {{ $t('quan-xuan') }}
          </a-checkbox>
          <span class="title check-num">
            {{
              $t('yi-xuan-statecheckedlistlength-ge', [
                state.checkedList.length,
              ])
            }}
          </span>
        </template>
        <span v-if="showTotal" class="ml-[8px]">
          <span v-if="max && total">
            {{
              total > max
                ? $t('zui-duo-zhan-shi-max-ge', [max])
                : $t('gong-total-ge-0', [total])
            }}
          </span>
          <span v-else>
            {{ $t('gong-total-ge-0', [total || displayList.length]) }}
          </span>
        </span>
      </div>
      <div class="flex-y-center gap-x-[8px]">
        <ClientOnly>
          <slot name="defaultBar"></slot>
          <slot
            name="batch"
            :checkable="state.checkable"
            :checkedList="state.checkedList"
          />
        </ClientOnly>
        <a-button
          v-if="patch"
          type="primary"
          :disabled="disabledPatchButton || !total"
          ghost
          @click="handleChangeCheck"
        >
          {{ state.checkable ? $t('tui-chu-cao-zuo') : $t('pi-liang-cao-zuo') }}
        </a-button>
      </div>
    </div>
    <a-spin :spinning="loading && !isBottom && displayList.length <= PAGE_SIZE">
      <!-- <ClientOnly> -->
      <EmptyView v-if="showEmpty">
        <template #content>
          <slot v-if="$slots.empty" name="empty"></slot>
          <div
            v-else
            class="text-[16px] text-[rgba(0,0,0,0.5)] leading-[23px] my-[8px]"
          >
            {{ empty || $t('zan-wu-shu-ju') }}
          </div>
        </template>
      </EmptyView>
      <!-- </ClientOnly> -->
      <div
        v-show="displayList.length"
        ref="listRef"
        class="list-card"
        :class="{ checkable: state.checkable }"
        @scroll="handleScroll"
      >
        <ul class="list-wrapper">
          <li v-if="showUpload" class="list-item extra" :style="itemStyle">
            <slot name="extra"></slot>
          </li>
          <template v-if="displayList.length">
            <li
              v-for="item of displayList"
              :key="item.id"
              class="list-item"
              :style="itemStyle"
            >
              <MainCard
                v-if="item?.type === CARD_TYPE.MAIN"
                :dataSource="item"
                :editableConfig="
                  checkCanEdit(item) ? editableConfig : undefined
                "
                :checked="
                  ((!item.status && item.status !== 0) ||
                    [
                      EXECUTION_STATUS.FINISHED,
                      EXECUTION_STATUS.CANCELED,
                    ].includes(item.status)) &&
                  state.checkable &&
                  !item?.limited
                "
                :avatarJumpable="avatarJumpable"
              >
                <template #cover>
                  <div
                    class="absolute top-0 w-full h-full cursor-pointer"
                    @click="handleClick(item)"
                  >
                    <div
                      v-if="
                        ((!item.status && item.status !== 0) ||
                          [
                            EXECUTION_STATUS.FINISHED,
                            EXECUTION_STATUS.CANCELED,
                          ].includes(item.status)) &&
                        state.checkable &&
                        !item?.limited
                      "
                      class="absolute top-[10px] right-[10px] w-[20px] h-[20px]"
                    >
                      <a-checkbox
                        :checked="state.checkedList.includes(item.id)"
                      />
                    </div>
                    <slot v-else name="cover" :dataSource="item"></slot>
                  </div>
                </template>
                <slot
                  v-if="$slots?.global"
                  name="global"
                  :dataSource="item"
                ></slot>
                <template
                  v-if="$slots?.menu && !state.checkable && !item.isDelete"
                  #menu
                >
                  <slot name="menu" :dataSource="item"></slot>
                </template>
                <template v-if="$slots?.expand" #expand>
                  <slot name="expand" :dataSource="item"></slot>
                </template>
                <template v-if="$slots?.task" #task>
                  <slot name="task" :dataSource="item"></slot>
                </template>
                <template v-if="$slots.right" #right>
                  <slot name="right" :dataSource="item"></slot>
                </template>
              </MainCard>
              <MaterialCard
                v-if="item?.type === CARD_TYPE.MATERIAL"
                :data-source="item"
                :editableConfig="
                  checkCanEdit(item) ? editableConfig : undefined
                "
                :checked="!item.status && state.checkable"
              >
                <template #cover>
                  <div
                    class="absolute top-0 w-full h-full cursor-pointer"
                    @click="handleClick(item)"
                  >
                    <div
                      v-if="state.checkable"
                      class="absolute top-[10px] right-[10px] w-[20px] h-[20px]"
                    >
                      <a-checkbox
                        :checked="state.checkedList.includes(item.id)"
                      />
                    </div>
                    <slot v-else name="cover" :dataSource="item"></slot>
                  </div>
                </template>
                <template
                  v-if="
                    $slots?.menu &&
                    !state.checkable &&
                    !item.isDelete &&
                    (isShowMenu ? !getSelfPerson(item) : true)
                  "
                  #menu
                >
                  <slot name="menu" :dataSource="item"></slot>
                </template>
                <template v-if="$slots?.expand" #expand>
                  <slot name="expand" :dataSource="item"></slot>
                </template>
                <template #close>
                  <slot name="close" :dataSource="item"></slot>
                </template>
              </MaterialCard>
              <TimbreCard
                v-if="item?.type === CARD_TYPE.TIMBRE"
                :data-source="item"
                :editableConfig="
                  checkCanEdit(item) ? editableConfig : undefined
                "
                :checked="!item.status && state.checkable"
                @click="handleClick(item)"
              >
                <template #leftTop>
                  <div v-if="!state.checkable">
                    <slot name="cover" :dataSource="item"></slot>
                  </div>
                </template>
                <template #rightTop>
                  <div v-if="state.checkable">
                    <a-checkbox
                      :checked="state.checkedList.includes(item.id)"
                    />
                  </div>
                  <div v-else class="relative">
                    <iconpark-icon
                      v-if="item.is_new"
                      size="40"
                      class="absolute top-[-10px] right-[0px]"
                      name="high-new"
                    ></iconpark-icon>
                  </div>
                </template>
              </TimbreCard>
              <MusicCard
                v-if="item?.type === CARD_TYPE.MUSIC"
                :data-source="item"
                :editableConfig="
                  checkCanEdit(item) ? editableConfig : undefined
                "
                :checked="!item.status && state.checkable"
              >
                <template #cover>
                  <div
                    class="absolute top-0 w-full h-full cursor-pointer"
                    @click="handleClick(item)"
                  >
                    <div
                      v-if="state.checkable"
                      class="absolute top-[10px] right-[10px] w-[20px] h-[20px]"
                    >
                      <a-checkbox
                        :checked="state.checkedList.includes(item.id)"
                      />
                    </div>
                    <slot v-else name="cover" :dataSource="item"></slot>
                  </div>
                </template>
                <template
                  v-if="$slots?.menu && !state.checkable && !item.isDelete"
                  #menu
                >
                  <slot name="menu" :dataSource="item"></slot>
                </template>
                <template v-if="$slots?.expand" #expand>
                  <slot name="expand" :dataSource="item"></slot>
                </template>
                <template #close>
                  <slot name="close" :dataSource="item"></slot>
                </template>
              </MusicCard>
              <PureCard
                v-if="item?.type === CARD_TYPE.PURE"
                :data-source="item"
                :editableConfig="
                  checkCanEdit(item) ? editableConfig : undefined
                "
                :checked="!item.status && state.checkable"
              >
                <template #cover>
                  <div
                    class="absolute top-0 w-full h-full cursor-pointer"
                    @click="handleClick(item)"
                  >
                    <div
                      v-if="state.checkable"
                      class="absolute top-[10px] right-[10px] w-[20px] h-[20px]"
                    >
                      <a-checkbox
                        :checked="state.checkedList.includes(item.id)"
                      />
                    </div>
                    <slot v-else name="cover" :dataSource="item"></slot>
                  </div>
                </template>
                <template
                  v-if="$slots?.menu && !state.checkable && !item.isDelete"
                  #menu
                >
                  <slot name="menu" :dataSource="item"></slot>
                </template>
              </PureCard>
            </li>
          </template>
        </ul>
        <div
          v-if="loading && displayList.length > PAGE_SIZE"
          class="w-full flex justify-center items-center pb-[30px]"
        >
          <a-spin />
        </div>
        <Divider
          v-if="
            (total === displayList.length || noMore) &&
            Math.ceil(displayList.length / PAGE_SIZE) > 1
          "
          class="!mt-[42px] !mb-[30px]"
        />
      </div>
    </a-spin>
  </div>
</template>
<script lang="ts" name="CardList" setup>
import type { CSSProperties } from 'vue'
import {
  MainCard,
  MaterialCard,
  MusicCard,
  PureCard,
  TimbreCard,
} from './components'
import type { IEditableConfig, IMediaCard } from '.'
import { PAGE_SIZE } from '~/constants'
import { PageKey } from '~/constants/page'

const { $t } = useNuxtApp()
// const listRef = ref()
const shareVisible = useShare()

const props = withDefaults(
  defineProps<{
    list: IMediaCard[]
    editableConfig?: IEditableConfig
    showUpload?: boolean
    loading?: boolean
    empty?: string
    max?: number
    total?: number
    patch?: boolean // 是否允许批量操作
    itemStyle?: CSSProperties
    showNoData?: boolean // 显示空白页
    showTotal?: boolean // 显示总数
    noMore?: boolean // 是否还可继续加载
    avatarJumpable?: boolean // 点击头像是否可以跳转
  }>(),
  {
    list: () => [],
    showUpload: false,
    loading: false,
    patch: true,
    // empty: ,
    showNoData: true,
    showTotal: true,
    noMore: false,
    avatarJumpable: true,
  }
)
const emits = defineEmits(['select-change', 'loadMore', 'card-click'])
const listRef = ref()
const isBottom = ref(false)
const noLogin = ref(false)
const route = useRoute()

const state = reactive<{
  checkable: boolean
  indeterminate: boolean
  checkAll: boolean
  checkedList: number[]
}>({
  checkable: false,
  indeterminate: false,
  checkAll: false,
  checkedList: [],
})

const displayList = computed(() => {
  if (state.checkable) {
    return props.list.filter((v) => !v.isDelete)
  }
  return props.list
})

// 团队空间定制人物不允许出现下拉操作项
const isShowMenu = computed(
  () =>
    route.name === PageKey.TEAM_SPACE &&
    Number(route.query?.resource_type) === RESOURCE_TYPE.PERSON
)

// 是定制人物
const getSelfPerson = (data: IMediaCard) => {
  return !data.is_user_upload && data.config_type === 1
}

useBackToTop(() => {
  if (displayList.value.length) {
    return {
      scrollContainer: '.list-card',
      item: '.list-item',
      total: props.max
        ? Math.min(props.max, props.total || 0)
        : props.total || 0,
    }
  }
  return undefined
})

const checkAllList = computed(
  () =>
    props.list
      ?.filter(
        (item) =>
          !item.isDelete &&
          ((!item.status && item.status !== 0) ||
            [EXECUTION_STATUS.FINISHED, EXECUTION_STATUS.CANCELED].includes(
              item.status
            )) &&
          !item?.limited
      )
      .map((item) => item.id)
)

const showEmpty = computed(() => {
  if (!props.showNoData) {
    return false
  }

  if (noLogin.value) {
    return true
  }

  return props?.list.length === 0 && !props?.loading
})

const disabledPatchButton = computed(() => {
  if (props?.list.length) {
    const temp = props?.list.filter((item: any) =>
      [
        EXECUTION_STATUS.ERROR,
        EXECUTION_STATUS.PROCESSING,
        EXECUTION_STATUS.WAITING,
        EXECUTION_STATUS.NOT_STARTED,
        EXECUTION_STATUS.DATA_INIT,
      ].includes(item.status)
    )
    return props?.list?.length === temp?.length
  }
  return false
})

// 非成功状态不可编辑名称
const checkCanEdit = (item: any) => {
  return ![
    EXECUTION_STATUS.ERROR,
    EXECUTION_STATUS.PROCESSING,
    EXECUTION_STATUS.WAITING,
    EXECUTION_STATUS.NOT_STARTED,
    EXECUTION_STATUS.DATA_INIT,
  ].includes(item.status)
}

const onCheckAllChange = (e: any) => {
  Object.assign(state, {
    checkedList: e.target.checked ? checkAllList.value : [],
    indeterminate: false,
  })
  emits('select-change', e.target.checked ? checkAllList.value : [])
}

watch([() => state.checkedList, () => checkAllList.value], ([val, allList]) => {
  const l = allList.length
  state.indeterminate = !!val.length && val.length < l
  state.checkAll = val.length === l
})

const handleChangeCheck = () => {
  state.checkable = !state.checkable
  if (!state.checkable) {
    state.checkedList = []
  }
}

const handleResetMultipleSelect = (checkable = false) => {
  state.checkable = checkable
  state.checkedList = []
}

const getDom = () => listRef.value

const handleClick = (values: any) => {
  if (state.checkable) {
    const temp = [...state.checkedList]
    const index = temp.findIndex((item) => item === values.id)
    if (index !== -1) {
      temp.splice(index, 1)
    } else {
      temp.push(values.id)
    }

    state.checkedList = temp
    emits('select-change', temp)
  } else {
    emits('card-click', values)
  }
}

// 监听滚动
const handleScroll = (e: Event) => {
  const { scrollTop, clientHeight, scrollHeight } = e.target as HTMLElement

  if (props.noMore) {
    return
  }

  // 滚动至底部
  if (Math.round(scrollTop + clientHeight) >= scrollHeight - 1) {
    emits('loadMore')
    isBottom.value = true
  } else {
    isBottom.value = false
  }

  if (!shareVisible.value) {
    return
  }

  shareVisible.value = false
}

defineExpose({
  reset: handleResetMultipleSelect,
  getDom,
})

onMounted(() => {
  const session = useSession()
  noLogin.value =
    typeof session.value === 'undefined' ||
    Object.keys(session.value ?? {}).length === 0
})
</script>
<style lang="scss" scoped>
.list-container {
  @apply relative w-full h-full rounded-[2px];
  .list-header {
    @apply flex-between mb-[10px];

    .check-num {
      &::before {
        @apply content-[''] inline-block w-[1px] h-[12px] bg-back-5 mr-[12px];
      }
    }
    .title {
      @apply text-[14px] leading-[22px] font-normal;
      color: var(--text-1-50);
    }
  }
  .list-card {
    position: relative;
    padding-block-start: 10px;
    .list-wrapper {
      @apply grid grid-cols-4 smd:grid-cols-3 mxl:grid-cols-5 gap-x-[24px] gap-y-[20px] w-full min-h-[156px];

      .list-item {
        @apply w-full h-auto select-none transform-gpu transition-all duration-300;
        list-style: none;
        border-radius: 10px;

        :deep(.ant-checkbox-inner) {
          width: 18px;
          height: 18px;
        }

        :deep(.card-cover) {
          padding-top: 56.25%;
          .cover-img {
            @apply absolute z-0 top-0 left-0;
          }
        }
      }

      .list-item:not(.extra) {
        &:hover {
          transform: translateY(-6px);
          box-shadow: 0px 1px 18px 0px rgba(4, 14, 48, 0.1);
        }
      }
    }
  }

  &.empty {
    :deep(.ant-spin-nested-loading) {
      // height: 0 !important;
    }

    :deep(.ant-spin-container) {
      overflow: auto;
    }
  }
}
</style>
